import { AppState } from '@store/AppState';
import { ContractState } from '@store/essential-ui/contract/ContractSlice';
import { useSelector } from 'react-redux';

export const useContract = (): ContractState => {
  const { contract, loading, error } = useSelector<AppState, ContractState>(
    (state) => state.contract,
  );

  return {
    contract: contract,
    loading: loading,
    error: error,
  };
};
